import { AlertTypes } from "../enums/inline-alert";

export class ConfirmModalActionsVm {
    constructor() { }
    title?: string;
    description?: string;
    confirmText?: string;
    cancelText?: string
    customAction?: () => any | undefined;
    customCloseAction!: () => any | undefined;
    inputs: any | undefined;
    successModal?: boolean;
    iconType?: AlertTypes;
}
